import { createColumnHelper } from "@tanstack/react-table"
import DataTableSimples from "../../../../components/dataTable/DataTableSimples"

export default function DespesasGraficoTabela({ dados, filtro, titulo, tabela, filtroDados }: iProps) {
    if (dados.length === 0) {
        return (
            <div>
            </div>
        )
    }

    const moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    const columnHelper = createColumnHelper<iReqMetrics>();
    const defaultColumns = [
        columnHelper.accessor("nome", {
            header: tabela,
            size: 500
        }),
        columnHelper.accessor("qtd", {
            header: "Quantidade",
        }),
        columnHelper.accessor("valor", {
            header: "Valor",
        }),
        columnHelper.accessor(row => `${row.porcentagem} %`, {
            header: "Porcentagem",
        }),
    ];
    const defaultOrder = [
        {
            id: "qtd",
            desc: true,
        },
    ];

    let registros: iReqMetrics[] = []
    let totalRegs = 0

    for (let reg of dados) {
        let descricao = ""
        let pular = false
        switch (filtro) {
            case 'empresas':
                descricao = reg.id_empresa.nome
                break
            case 'usuarios':
                const id_colaborador = reg.id_relatorio.id_colaborador
                const usuarios: any[] = filtroDados.usuarios.filter((reg:any) => reg.id_colaborador === id_colaborador)
                if (usuarios.length === 0) { break }
                const usuario = usuarios[0]
                descricao = usuario.nome
                break
            case 'formas_pagamento':
                descricao = reg.id_forma_pagamento.descricao
                break
            case 'categorias':
                descricao = reg.id_categoria.descricao
                break
            case 'clientes':
                descricao = reg.id_cliente.descricao
                break
            case 'cartoes':
                if (reg.id_cartao?.id_cartao === undefined) { pular = true; break; }
                const id_cartao = reg.id_cartao.id_cartao
                const cartoes: any[] = filtroDados.cartoes.filter((reg:any) => reg.id_cartao === id_cartao)
                if (cartoes.length === 0) { break }
                const cartao = cartoes[0]
                const nome_empresa = cartao.id_empresa.nome
                const nome_portador = String(cartao.nome_portador).split(" ")[0]
                const num_cartao = String(cartao.num_cartao)
                const final_num_cartao = num_cartao.substring(num_cartao.length - 4)
                descricao = `${nome_empresa} - ${nome_portador} | ${final_num_cartao}`
                break
        }
        if (pular) { continue }

        let pesquisa = registros.filter(reg => reg.nome === descricao)
        let existe = pesquisa.length > 0 ? true : false
        if (!existe) {
            totalRegs += 1
            registros.push({
                nome: descricao,
                valor: reg.valor,
                qtd: 1,
                porcentagem: `0`,
            })
        }
        if (existe) {
            let index = registros.indexOf(pesquisa[0])
            if (index < 0) {
                continue
            }
            totalRegs += 1
            registros[index].valor = Number(Number(registros[index].valor) + Number(reg.valor)).toFixed(2)
            registros[index].qtd = registros[index].qtd + 1
        }
    }

    registros.sort(function (a, b) { return Number(b.valor) - Number(a.valor) })

    // Calcular total dos registros
    let registrosTotais = {
        qtd: 0,
        valor: "",
        porcentagem: "0"
    }
    for (let idx in registros) {
        const qtd = registros[idx].qtd
        registros[idx].porcentagem = ((qtd * 100) / totalRegs).toFixed(2)
        let reg = registros[idx]
        let porcentagem = reg.porcentagem
        registrosTotais.porcentagem = Number(Number(registrosTotais.porcentagem) + Number(porcentagem)).toFixed(2)
        registrosTotais.qtd += qtd
        registrosTotais.valor = Number(Number(registrosTotais.valor) + Number(reg.valor)).toFixed(2)

        registros[idx].valor = moneyFormatter.format(Number(reg.valor))
    }
    registrosTotais.porcentagem = "100.00"
    registrosTotais.valor = moneyFormatter.format(Number(registrosTotais.valor))

    function tableMiddleClickhandler(event: any) {
        // const idx = Number(event.target.parentElement.getAttribute("about"))
    }
    function tableClickhandler(event: any) {
        // const idx = Number(event.target.parentElement.getAttribute("about"))
    }

    return (
        <div style={{ width: "50%", margin: "10px 10px 10px 0px" }}>
            <p style={{ fontWeight: "bold", textTransform: "uppercase", backgroundColor: "#dadada", padding: "2px 4px" }}>{titulo}</p>
            <DataTableSimples
                dados={registros}
                tableSize={"auto"}
                defaultColumns={defaultColumns}
                tableMiddleClickhandler={tableMiddleClickhandler}
                tableClickhandler={tableClickhandler}
                defaultOrder={defaultOrder}
                dadosTotais={registrosTotais}
            />
        </div>
    )
}
interface iProps {
    dados: any[]
    filtro: "empresas" | "usuarios" | "categorias" | "clientes" | "formas_pagamento" | "cartoes"
    titulo: string
    tabela: string
    filtroDados: any
}

export interface iReqMetrics {
    nome: string
    qtd: number
    valor: string
    porcentagem: string
}

